export default function NameDispose(str) {
    let index = str.indexOf('、');
    let res = [];
    if (index == -1) {
        res.push(str)
    } else {
        let head = str.slice(0, index - 1);
        let flag = 0
        while (index != -1) {
            flag = index
            res.push(head + str[index - 1])
            index = str.indexOf('、', index + 1);
        }
        let last = str.slice(flag + 3, str.length);
        res.push(head + str[flag + 2]);
        res.map((i, index) => {
            res[index] = i + last
        })
    }
    return res
}
